import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import formControl from "globals/form-control";
import CTLUnReadCell from "application/components/CTLUnReadCell";
import { extensionMenus } from "globals/configuration/extension";

const Attributes = {
  formSize: "md",
  columns: 3,
  enableAddButton: true,
  enableAdvanceSearch: true,
  enableGroupHeading: false,
  verticalTabs: false,
  tabSize: 4,
  modes: extensionMenus.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
      submenu: item.submenu
        ? item.submenu.map((subItem) => {
            return {
              id: subItem.key,
              name: subItem.name,
              iconName: subItem.icon,
              url: subItem.url,
              description: subItem.description,
            };
          })
        : [],
    };
  }),
  settingsMode: false,
};

const operationURLS = {
  list: "/pulseMaster/filteredList",
  update: "/pulseMaster/update",
  register: "/pulseMaster/create",
  delete: "/pulseMaster/delete",
};

const getColumns = (onDelete, onEdit) => {
  return [
    {
      Header: "Pulse Code",
      accessor: "pulseCode",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      validation: formControl.string().required("Required"),
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Gateway Code",
      accessor: "gateway",
      displayInList: true,
      allowFilter: true,
      allowInForm: true,
      dataType: "string",
      width: 6,
      validation: formControl.string().required("Required"),
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
      controlType: "select",
      filterControlType: "select",
      options: {
        keyField: "gwCode",
        keyDescription: "gwCode",
        values: [],
        url: "gateway/listAll/gwCode",
      },
    },
    {
      Header: "From Time",
      accessor: "fromTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "time",
      sortDisable: true,
      defaultValue: "00:01",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "To Time",
      accessor: "toTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "time",
      defaultValue: "23:59",
      sortDisable: true,
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Range",
      accessor: "range",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      validation: formControl.string().required("Required").digitsOnly(),
      Cell: ({ value }) => <DefaultCell value={value} />,
    },

    {
      Header: "Pulse (in sec)",
      accessor: "pulse",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Rate(in paisa)",
      accessor: "rate",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      ),
    },
  ];
};

export { getColumns, Attributes, operationURLS };
